module.exports = __webpack_public_path__ + "img/awg.58fd8267.png";